/* eslint-disable import/prefer-default-export */
import { ENDPOINTS } from './endpoints';
import { fetchData } from './network';
import { bindLocaleIntoHeaders } from '../utils/resolve-locale';

export function getAcademicsPage() {
  const url = new URL(`${process.env.API_URL}${ENDPOINTS.getAcademicsPage.path}`);

  bindLocaleIntoHeaders(url);
  url.searchParams.append('populate[portrait_of_graduate][populate]', '*');
  url.searchParams.append('populate[learning_experience][populate]', '*');
  url.searchParams.append('populate[scholarly_inquiry][populate]', '*');
  url.searchParams.append('populate[hero_image_1][populate]', '*');
  url.searchParams.append('populate[hero_image_2][populate]', '*');

  return fetchData(url, {
    method: ENDPOINTS.getAcademicsPage.method
  }).then((response) => response);
}

export function getAcademicCalendarAndCourseInfo() {
  const url = new URL(`${process.env.API_URL}/academic-calendar-and-course-info`);
  url.searchParams.append('populate[academic_calendars][populate]', '*');
  url.searchParams.append('populate[course_catalogs][populate]', '*');
  bindLocaleIntoHeaders(url);

  return fetchData(url, {
    method: ENDPOINTS.getAcademicsPage.method
  }).then((response) => response);
}
